import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

// Loads GA4 (gtag.js) from the admin-configured Measurement ID and fires a
// page_view on every SPA route change (React Router does not reload the page,
// so pageviews must be sent manually).
const GoogleAnalytics = () => {
  const settings = useSettings();
  const gaId = (settings?.seo?.google_analytics_id || '').trim();
  const location = useLocation();
  const loadedId = useRef(null);

  // Inject the gtag script once, when a valid ID is available.
  useEffect(() => {
    if (!gaId || loadedId.current === gaId) return;
    loadedId.current = gaId;

    if (!document.querySelector(`script[data-ga-id="${gaId}"]`)) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      s.setAttribute('data-ga-id', gaId);
      document.head.appendChild(s);
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    // Disable automatic first page_view; we send it manually below on route change.
    gtag('config', gaId, { send_page_view: false });
  }, [gaId]);

  // Fire a page_view on every route change (and initial load once configured).
  useEffect(() => {
    if (!gaId || typeof window.gtag !== 'function') return;
    if (location.pathname.startsWith('/admin')) return; // don't track the admin panel
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [gaId, location.pathname, location.search]);

  return null;
};

export default GoogleAnalytics;
